export default __webpack_public_path__ + "fd833600ca1cc018d81c253c22b34ecd.png";